import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UserSessionExpirationComponent } from './user-session-expiration.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		NgxZeroStateModule
	],
	exports: [
		UserSessionExpirationComponent
	],
	declarations: [
		UserSessionExpirationComponent
	]
})
export class UserSessionExpirationModule {}
